import { trimText } from "../../../../core/lib/utilities";
import { CoastMediaEpisodeNode } from "./CoastMedia.util";

interface CoastMediaEpisodeProps {
  setCurrentEpisode: (episode: CoastMediaEpisodeNode, groupSlug: string) => void;
  episode: CoastMediaEpisodeNode;
  groupSlug: string;
}

const FALLBACK_THUMBNAIL =
  "https://i.iheart.com/v3/re/assets.coast2coast/7ee1f60d-5b5d-4f98-8dac-4b2d3c41909f?ops=fit(300,175)";

export function CoastMediaEpisode({ episode, setCurrentEpisode, groupSlug }: CoastMediaEpisodeProps) {
  const { title, thumbnails, description } = episode.data;

  return (
    <figure className="component-coast-media-episode">
      <div className="thumb-container" onClick={() => setCurrentEpisode(episode, groupSlug)}>
        <img
          // optional chaining here makes Mobx unhappy
          src={(thumbnails.length && thumbnails[0].url) || FALLBACK_THUMBNAIL}
          alt={`Logo for episode titled ${title}`}
          className="thumbnail"
        />
      </div>

      <figcaption>
        <h5 className="title" onClick={() => setCurrentEpisode(episode, groupSlug)}>
          {title}
        </h5>
        <p className="description">{trimText(description, 55)}</p>
      </figcaption>
    </figure>
  );
}
